import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";  // Import useNavigate for routing
import SignInButton from "./SignInButton";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const authToken = useSelector((state) => state.auth.authToken); 

    const navigate = useNavigate();  // Initialize useNavigate hook

    const menuOptions = authToken
        ? [
              { label: "Profile", href: "/profile" },
              { label: "Log Out", href: "/logout" },
          ]
        : [
              { label: "WTF is this?", href: "#Wit" },
              { label: "Advertise with us", href: "#Ad" },
              { label: "Sign in with Google", component: <SignInButton /> },
          ];

    return (
        <nav className="fixed top-0 left-0 w-full flex items-center justify-between p-4 bg-red-600 text-white z-50 h-16">
            {/* Logo Section */}
            <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
                <img src="/logo.png" alt="Wish3s Logo" className="h-10" />
            </div>

            {/* Mobile Menu Button */}
            <button
                className="sm:hidden p-2 text-white hover:text-gray-300 focus:outline-none flex items-center"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
                {isMobileMenuOpen ? (
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                ) : (
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h18M3 12h18m-18 7h18" />
                    </svg>
                )}
            </button>

            {/* Desktop Menu */}
            <div className="hidden sm:flex space-x-6 items-center">
                {menuOptions.map((option, index) =>
                    option.component ? (
                        <div key={index}>{option.component}</div>
                    ) : (
                        <a key={index} href={option.href} className="text-white hover:text-gray-300">
                            {option.label}
                        </a>
                    )
                )}
            </div>

            {/* Mobile Menu Dropdown */}
            {isMobileMenuOpen && (
                <div className="sm:hidden absolute top-16 left-0 w-full bg-red-600 text-white flex flex-col space-y-4 p-4 items-center">
                    {menuOptions.map((option, index) =>
                        option.component ? (
                            <div key={index}>{option.component}</div>
                        ) : (
                            <a key={index} href={option.href} className="text-white hover:text-gray-300">
                                {option.label}
                            </a>
                        )
                    )}
                </div>
            )}
        </nav>
    );
};

export default Navbar;
